import {
  ArrowUpRightIcon,
  Button,
  Card,
  Flex,
  Heading,
  Text,
} from '@buffer-mono/popcorn'

import styles from './CliPromoCard.module.css'

import type { JSX } from 'react'

const CLI_DOCS_URL = 'https://developers.buffer.com/guides/cli.html'

export function CliPromoCard(): JSX.Element {
  return (
    <Card className={styles.card}>
      <Flex direction="column" gap="md">
        <Flex direction="column" gap="2xs">
          <Heading as="h3" size="xsmall">
            Buffer CLI
          </Heading>

          <Text color="subtle">
            Buffer in your terminal: Fast, scriptable, and built for devs.
          </Text>
        </Flex>

        <Button
          as="a"
          href={CLI_DOCS_URL}
          target="_blank"
          rel="noopener noreferrer"
          variant="secondary"
          size="large"
        >
          Get Started
          <ArrowUpRightIcon />
        </Button>
      </Flex>
    </Card>
  )
}
